import { render } from "./addNewEl.vue?vue&type=template&id=1e08f779&scoped=true"
import script from "./addNewEl.vue?vue&type=script&lang=js"
export * from "./addNewEl.vue?vue&type=script&lang=js"

import "./addNewEl.vue?vue&type=style&index=0&id=1e08f779&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1e08f779"

export default script